import React from 'react';
import PropTypes from 'prop-types';
import * as d3 from 'd3';
import Points from '../Points';
import { boundedSeries } from '../../utils/boundedseries';
import GriffPropTypes from '../../utils/proptypes';

var Line = function Line(_ref) {
  var data = _ref.data,
      xAxisAccessor = _ref.xAxisAccessor,
      xScale = _ref.xScale,
      yAccessor = _ref.yAccessor,
      y0Accessor = _ref.y0Accessor,
      y1Accessor = _ref.y1Accessor,
      yScale = _ref.yScale,
      color = _ref.color,
      step = _ref.step,
      hidden = _ref.hidden,
      drawPoints = _ref.drawPoints,
      strokeWidth = _ref.strokeWidth,
      opacity = _ref.opacity,
      pointWidth = _ref.pointWidth,
      pointWidthAccessor = _ref.pointWidthAccessor,
      clipPath = _ref.clipPath;
  var line = void 0;
  var area = void 0;

  if (step) {
    line = d3.line().curve(d3.curveStepAfter).x(function (d) {
      return boundedSeries(xScale(xAxisAccessor(d)));
    }).y(function (d) {
      return boundedSeries(yScale(yAccessor(d)));
    });

    if (drawPoints !== true && y0Accessor && y1Accessor) {
      area = d3.area().curve(d3.curveStepAfter).x(function (d) {
        return boundedSeries(xScale(xAxisAccessor(d)));
      }).y0(function (d) {
        return boundedSeries(yScale(y0Accessor(d)));
      }).y1(function (d) {
        return boundedSeries(yScale(y1Accessor(d)));
      });
    }
  } else {
    line = d3.line().x(function (d) {
      return boundedSeries(xScale(xAxisAccessor(d)));
    }).y(function (d) {
      return boundedSeries(yScale(yAccessor(d)));
    });

    if (drawPoints !== true && y0Accessor && y1Accessor) {
      area = d3.area().x(function (d) {
        return boundedSeries(xScale(xAxisAccessor(d)));
      }).y0(function (d) {
        return boundedSeries(yScale(y0Accessor(d)));
      }).y1(function (d) {
        return boundedSeries(yScale(y1Accessor(d)));
      });
    }
  }

  var circles = null;

  if (drawPoints) {
    var xSubDomain = xScale.domain();
    circles = React.createElement(Points, {
      data: data.filter(function (d) {
        var x = xAxisAccessor(d);
        return x >= xSubDomain[0] && x <= xSubDomain[1];
      }),
      drawPoints: drawPoints,
      xAccessor: xAxisAccessor,
      yAccessor: yAccessor,
      xScale: xScale,
      yScale: yScale,
      color: color,
      pointWidth: pointWidth,
      pointWidthAccessor: pointWidthAccessor
    });
  }

  return React.createElement('g', {
    clipPath: 'url(#' + clipPath + ')'
  }, area && React.createElement('path', {
    className: 'line-area',
    d: area(data),
    style: {
      stroke: color,
      strokeOpacity: 0,
      strokeWidth: strokeWidth + 'px',
      fill: color,
      fillOpacity: 0.25,
      opacity: 1,
      display: hidden ? 'none' : 'inherit'
    }
  }), React.createElement('path', {
    className: 'line',
    d: line(data),
    style: {
      stroke: color,
      strokeWidth: strokeWidth + 'px',
      strokeOpacity: opacity,
      fill: 'none',
      display: hidden ? 'none' : 'inherit'
    }
  }), circles);
};

Line.propTypes = process.env.NODE_ENV !== "production" ? {
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  // eslint-disable-next-line
  data: PropTypes.array.isRequired,
  // Data can take any form as long as the xAxisAccessor and yAccessors are set.
  xAxisAccessor: PropTypes.func.isRequired,
  yAccessor: PropTypes.func.isRequired,
  y0Accessor: PropTypes.func,
  y1Accessor: PropTypes.func,
  color: PropTypes.string.isRequired,
  step: PropTypes.bool,
  hidden: PropTypes.bool,
  drawPoints: GriffPropTypes.drawPoints,
  opacity: PropTypes.number,
  pointWidth: PropTypes.number,
  pointWidthAccessor: PropTypes.func,
  strokeWidth: PropTypes.number,
  clipPath: PropTypes.string.isRequired
} : {};
Line.defaultProps = {
  step: false,
  hidden: false,
  drawPoints: false,
  opacity: 1,
  pointWidth: 6,
  pointWidthAccessor: null,
  strokeWidth: 1,
  y0Accessor: null,
  y1Accessor: null
};
export default Line;